import axios from "axios";

const API_BASE = "https://api.lart2vendreimmobilier.com";

function getHeaders() {
  const token = localStorage.getItem("adv_stats");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export async function listFolder(folderPath = "/") {
  const res = await axios.get(`${API_BASE}/fm/list`, {
    headers: getHeaders(),
    params: { path: folderPath },
  });
  return res.data;
}

export async function createFolder(folderPath) {
  const res = await axios.post(
    `${API_BASE}/fm/mkdir`,
    { path: folderPath },
    { headers: getHeaders() }
  );
  return res.data;
}

export async function renameItem(oldPath, newName) {
  const res = await axios.post(
    `${API_BASE}/fm/rename`,
    { oldPath, newName },
    { headers: getHeaders() }
  );
  return res.data;
}

export async function deleteItems(paths) {
  const res = await axios.post(
    `${API_BASE}/fm/delete`,
    { paths },
    { headers: getHeaders() }
  );
  return res.data;
}

export async function moveItems(sourcePaths, destPath) {
  const res = await axios.post(
    `${API_BASE}/fm/move`,
    { sourcePaths, destPath },
    { headers: getHeaders() }
  );
  return res.data;
}

export async function copyItems(sourcePaths, destPath) {
  const res = await axios.post(
    `${API_BASE}/fm/copy`,
    { sourcePaths, destPath },
    { headers: getHeaders() }
  );
  return res.data;
}

export function getUploadUrl(folder = "/") {
  return `${API_BASE}/fm/upload?folder=${encodeURIComponent(folder)}`;
}

export function getUploadHeaders() {
  const token = localStorage.getItem("adv_stats");
  return { Authorization: `Bearer ${token}` };
}

export function getDownloadUrl(filePath) {
  return `${API_BASE}/fm/download?path=${encodeURIComponent(filePath)}`;
}

export async function getFolderOrder() {
  const res = await axios.get(`${API_BASE}/fm/order`, {headers: getHeaders()});
  return res.data.order || [];
}

export async function saveFolderOrder(order) {
  await axios.post(`${API_BASE}/fm/order`, {order}, {headers: getHeaders()});
}

export async function getPrefs() {
  const res = await axios.get(`${API_BASE}/fm/prefs`, {headers: getHeaders()});
  return res.data.prefs || {};
}

export async function savePrefs(prefs) {
  await axios.post(`${API_BASE}/fm/prefs`, {prefs}, {headers: getHeaders()});
}
